/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Timing_Sync_Selected_LabelInputs */

const en_timing_sync_selected_label = /** @type {(inputs: Timing_Sync_Selected_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selected`)
};

const fr_timing_sync_selected_label = /** @type {(inputs: Timing_Sync_Selected_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selectionne`)
};

const de_timing_sync_selected_label = /** @type {(inputs: Timing_Sync_Selected_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ausgewählt`)
};

const it_timing_sync_selected_label = /** @type {(inputs: Timing_Sync_Selected_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selezionato`)
};

const ru_timing_sync_selected_label = /** @type {(inputs: Timing_Sync_Selected_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Избранные`)
};

const es_timing_sync_selected_label = /** @type {(inputs: Timing_Sync_Selected_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleccionado`)
};

const zh_cn2_timing_sync_selected_label = /** @type {(inputs: Timing_Sync_Selected_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已选`)
};

const ja_timing_sync_selected_label = /** @type {(inputs: Timing_Sync_Selected_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`選択済み`)
};

const hi_timing_sync_selected_label = /** @type {(inputs: Timing_Sync_Selected_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`चयनित`)
};

const pt_pt2_timing_sync_selected_label = /** @type {(inputs: Timing_Sync_Selected_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecionado`)
};

/**
* | output |
* | --- |
* | "Selected" |
*
* @param {Timing_Sync_Selected_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const timing_sync_selected_label = /** @type {((inputs?: Timing_Sync_Selected_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timing_Sync_Selected_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_timing_sync_selected_label(inputs)
	if (locale === "de") return de_timing_sync_selected_label(inputs)
	if (locale === "it") return it_timing_sync_selected_label(inputs)
	if (locale === "ru") return ru_timing_sync_selected_label(inputs)
	if (locale === "es") return es_timing_sync_selected_label(inputs)
	if (locale === "zh-CN") return zh_cn2_timing_sync_selected_label(inputs)
	if (locale === "ja") return ja_timing_sync_selected_label(inputs)
	if (locale === "hi") return hi_timing_sync_selected_label(inputs)
	if (locale === "pt-PT") return pt_pt2_timing_sync_selected_label(inputs)
	return en_timing_sync_selected_label(inputs)
});